module.exports = __webpack_public_path__ + "static/media/dolomitenmarkt.a390dabb.svg";